var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mds-form__field-group",
      class: { "mds-form__field-group--error": _vm.v.$error }
    },
    [
      _c("mds-label", { attrs: { for: _vm.id, required: "" } }, [
        _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
      ]),
      _vm._v(" "),
      _vm.type === "checkbox"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputVal,
                expression: "inputVal"
              }
            ],
            staticClass: "mds-form__input mds-form__input--medium",
            attrs: {
              id: _vm.id,
              "aria-describedby": _vm.described,
              "aria-label": _vm.id,
              "aria-labelledby": _vm.id,
              type: "checkbox"
            },
            domProps: {
              checked: Array.isArray(_vm.inputVal)
                ? _vm._i(_vm.inputVal, null) > -1
                : _vm.inputVal
            },
            on: {
              change: function($event) {
                var $$a = _vm.inputVal,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.inputVal = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.inputVal = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.inputVal = $$c
                }
              }
            }
          })
        : _vm.type === "radio"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputVal,
                expression: "inputVal"
              }
            ],
            staticClass: "mds-form__input mds-form__input--medium",
            attrs: {
              id: _vm.id,
              "aria-describedby": _vm.described,
              "aria-label": _vm.id,
              "aria-labelledby": _vm.id,
              type: "radio"
            },
            domProps: { checked: _vm._q(_vm.inputVal, null) },
            on: {
              change: function($event) {
                _vm.inputVal = null
              }
            }
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputVal,
                expression: "inputVal"
              }
            ],
            staticClass: "mds-form__input mds-form__input--medium",
            attrs: {
              id: _vm.id,
              "aria-describedby": _vm.described,
              "aria-label": _vm.id,
              "aria-labelledby": _vm.id,
              type: _vm.type
            },
            domProps: { value: _vm.inputVal },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.inputVal = $event.target.value
              }
            }
          }),
      _vm._v(" "),
      _vm.id === "passwordInput" && _vm.value
        ? _c(
            "span",
            { staticClass: "password-show-icon" },
            [
              _c(
                "mds-button",
                {
                  staticClass: "showPasswordButton",
                  attrs: { type: "button", variation: "flat" },
                  on: { click: _vm.handleShowPassword }
                },
                [
                  _vm._v(
                    "\n                      " +
                      _vm._s(_vm.passwordText) +
                      "\n                    "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.v.$error,
              expression: "v.$error"
            }
          ],
          staticClass: "mds-form__field-error",
          attrs: { id: _vm.described, role: "alert" }
        },
        [_vm._v(" " + _vm._s(_vm.error) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }